import http from 'config/http';
import axios from 'axios';

import { ProjectAssetEnum, StatusEnum, UserRoleEnum } from 'api/enums';
import { IUserModel, UserModel } from 'api/models';
import { IUserPayload } from 'api/types';
import { getApiUrl } from 'config/api-url';

export const getAllUsersLean = async () => {
    const { data } = await http.get(`${getApiUrl()}/users/lean`);

    return UserModel.fromObjectList(data);
};

export const getAllTeams = async () => {
    const { data } = await http.get(`${getApiUrl()}/teams`);

    return data as string[];
};

export const getProjectUsersLean = async (projectId: string) => {
    const { data } = await http.get(`${getApiUrl()}/projects/${projectId}/users/lean`);

    return UserModel.fromObjectList(data);
};

export const getUserSpaceStorage = async (userId: string) => {
    const { data } = await http.get(`${getApiUrl()}/users/${userId}/storage-space`);

    return data as {
        totalSpace: number;
        totalSpaceUsed: number;
    };
};

export const checkUsernameExists = async (username: string, clientId: string) => {
    try {
        await axios.post(`${getApiUrl()}/users/username/unique`, { username, clientId });

        return false;
    } catch (err) {
        return true;
    }
};

export const checkEmailExists = async (email: string, clientId: string) => {
    try {
        await axios.post(`${getApiUrl()}/users/email/unique`, { email, clientId });

        return false;
    } catch (err) {
        return true;
    }
};

export const getActiveUserList = async () => {
    const { data } = await http.get(`${getApiUrl()}/users`);

    return data.map((row: IUserModel) => UserModel.fromObject(row)) as UserModel[];
};

export const getGuestUserList = async () => {
    const { data } = await http.get(`${getApiUrl()}/users/guest`);

    return data.map((row: IUserModel) => UserModel.fromObject(row)) as UserModel[];
};

export const createUser = async (payload: IUserPayload) => {
    const { data } = await http.post(`${getApiUrl()}/users`, payload);

    return UserModel.fromObject(data);
};

export const getUserById = async (userId: string) => {
    const { data } = await http.get(`${getApiUrl()}/users/${userId}`);

    return UserModel.fromObject(data);
};

export const getGuestUserById = async (guestUserId: string) => {
    const { data } = await http.get(`${getApiUrl()}/users/guest/${guestUserId}`);

    return UserModel.fromObject(data);
};

export const deleteUser = async (userId: string) => {
    await http.delete(`${getApiUrl()}/users/${userId}`);
};

export const updateUserStatus = async (userId: string, status: StatusEnum) => {
    await http.put(`${getApiUrl()}/users/${userId}/status`, { status });
};

export const updateUserRole = async (userId: string, role: UserRoleEnum) => {
    await http.put(`${getApiUrl()}/users/${userId}/role`, { role });
};

export const updateUserTags = async (userId: string, tags: string[]) => {
    await http.put(`${getApiUrl()}/users/${userId}/tags`, { tags });
};

// export const updateUserProjects = async (userId: string, projects: string[]) => {
//     await http.put(`${getApiUrl()}/users/${userId}/projects`, { projects });
// };

export const updateUserProjects = async (
    userId: string,
    projects: string[],
    projectAssetPermissions: Record<string, ProjectAssetEnum[]>
) => {
    await http.put(`${getApiUrl()}/users/${userId}/projects`, { projects, projectAssetPermissions });
};

// export const allowProjectAccessUser = async (userId: string, projectId: string) => {
//     await http.put(`${getApiUrl()}/users/${userId}/projects/${projectId}/access`);
// };

// export const revokeProjectAccessUser = async (userId: string, projectId: string) => {
//     await http.put(`${getApiUrl()}/users/${userId}/projects/${projectId}/revoke`);
// };

// export const allowProjectAssetAccess = async (userId: string, projectId: string, assetId: string) => {
//     await http.put(`${getApiUrl()}/users/${userId}/projects/${projectId}/assets/${assetId}/access`);
// };

// export const revokeProjectAssetAccess = async (userId: string, projectId: string, assetId: string) => {
//     await http.put(`${getApiUrl()}/users/${userId}/projects/${projectId}/assets/${assetId}/revoke`);
// };

export const resetUserPassword = async (userId: string, notifyByEmail: boolean) => {
    const { data } = await http.post(`${getApiUrl()}/users/${userId}/reset-password`, { notifyByEmail });

    return UserModel.fromObject(data) as Pick<UserModel, 'username' | 'password'>;
};

export const downloadExcel = async () => {
    const { data } = await http.get(`${getApiUrl()}/users/excel`, {
        responseType: 'blob',
    });

    return data;
};

export const getForceResetFlag = async () => {
    const { data } = await http.get(`${getApiUrl()}/users/force-reset-password/password-flag`);
    return data as {
        forceLogin: boolean;
        ssoEnable: boolean;
        microsoftSsoEnable: boolean;
    };
};

export const forceResetPassword = async (password: string) => {
    await http.post(`${getApiUrl()}/users/force-reset-password/reset`, { password });
};

export const sendEmailVerification = async () => {
    await http.post(`${getApiUrl()}/users/force-reset-password/send-otp`);
};

export const validateForceResetPassword = async (payload: { otp: string }) => {
    await http.post(`${getApiUrl()}/users/force-reset-password/validate-otp`, payload);
};

export const resendForceResetPassword = async () => {
    await http.post(`${getApiUrl()}/users/force-reset-password/resend`);
};
